<ng-template [appTopbarTemplate]>
  <div class="title h4">{{ texts.heading | localize }}</div>
</ng-template>

<div class="content" *ngIf="user">

  <!-- <div class="container mb-5">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="mb-0">{{ texts.heading | localize }}</h3>
      </div>
    </div>
  </div> -->

  <div class="container">

    <div class="row">

      <!-- Profil -->

      <div class="col-12" *ngIf="show == 'profile'">

        <div class="card">
          <div class="card-header">
            <h5 class="card-title">{{ texts.profile.title | localize }}</h5>
          </div>
          <div class="card-body">

            <div class="row">

              <div class="col-lg-8">

                <div class="form-group image-upload">

                  <label class="form-label small small">{{ texts.profile.image | localize }}</label>

                  <sc-file-button #fileButton class="form-control pe-3" (filesChanged)="upload($event)">

                    <div class="row">

                      <div class="col-auto">

                        <sc-avatar [user]="user" size="xs"></sc-avatar>

                      </div>

                      <div class="col ms-n3">

                        <div *ngIf="!isUploadingImage" class="text-muted">{{ texts.profile.selectImage | localize }}</div>
                        <div *ngIf="isUploadingImage">
                          <span class="spinner-border spinner-border-sm me-2 text-primary" role="status" aria-hidden="true"></span>
                          {{ texts.profile.uploadingImage | localize }}
                        </div>

                      </div>

                    </div>

                  </sc-file-button>

                  <div *ngIf="user?.Image" class="remove-image" (click)="clearImage()">
                    <i class="fa-regular fa-times"></i>
                  </div>

                </div>

              </div>

            </div>

            <div class="row">

              <div class="col-lg-8">
                <div class="form-group">

                  <!-- Label -->
                  <label class="form-label small">{{ texts.profile.firstName | localize }}</label>
                  <div class="input-group input-group-merge">
                    <input [(ngModel)]="user.FirstName" type="text" class="form-control">
                  </div>

                </div>
              </div>

            </div>

            <div class="row">

              <div class="col-lg-8">
                <div class="form-group">

                  <!-- Label -->
                  <label class="form-label small">{{ texts.profile.lastName | localize }}</label>
                  <div class="input-group input-group-merge">
                    <input [(ngModel)]="user.LastName" type="text" class="form-control">
                  </div>

                </div>

              </div>

            </div>

            <div class="row">

              <div class="col-lg-8">

                <div class="form-group">
                  <label class="form-label small">{{ texts.profile.email | localize }}</label>
                  <div class="input-group input-group-merge">
                    <input name="eMail" [(ngModel)]="user.EMail" disabled type="text" class="form-control">
                  </div>
                </div>

              </div>

            </div>

            <div class="row align-items-center" *ngIf="saveSuccess">
              <div class="col">
                <div class="alert alert-success mt-4" role="alert">
                  <p class="alert-heading mb-0">
                    <span class="icon me-3">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    {{ texts.profile.saveSuccess | localize }}
                  </p>
                </div>
              </div>
            </div>

            <button class="btn btn-dark mt-4" *ngIf="!saveSuccess" [disabled]="isSaving" (click)="save()">
              <span *ngIf="isSaving" class="spinner-border spinner-border-sm"></span>
              {{ texts.save | localize }}
            </button>

            <!-- <button class="btn btn-success mt-4" disabled *ngIf="saveSuccess">
              <i class="fe fe-check"></i> Übernommen
            </button> -->

          </div>
        </div>

      </div>

      <!-- Benachrichtigungen -->

      <div class="col-12 mt-5">

        <div class="card">
          <div class="card-header">
            <h5 class="card-title">{{ texts.notifications.title | localize }}</h5>
          </div>
          <div class="card-body">

            <div class="mb-3">
              <sc-checkbox [isChecked]="true" [disabled]="true">
                {{ texts.notifications.byMailTasks | localize }}
              </sc-checkbox>
            </div>

            <div class="mb-3">
              <sc-checkbox [(isChecked)]="settings.DisableNotifications">
                {{ texts.notifications.hideTasks | localize }}
              </sc-checkbox>
            </div>

            <div class="mb-3">
              <sc-checkbox [(isChecked)]="settings.SendAllNotifications">
                {{ texts.notifications.byMailAll | localize }}
              </sc-checkbox>
            </div>

            <div class="row align-items-center" *ngIf="saveNotificationsSuccess">
              <div class="col">
                <div class="alert alert-success mt-4" role="alert">
                  <p class="alert-heading mb-0">
                    <span class="icon me-3">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    {{ texts.notifications.saveSuccess | localize }}
                  </p>
                </div>
              </div>
            </div>

            <button class="btn btn-dark mt-4" *ngIf="!saveNotificationsSuccess" [disabled]="isSavingNotifications" (click)="saveNotifications()">
              <span *ngIf="isSavingNotifications" class="spinner-border spinner-border-sm"></span>
              {{ texts.save | localize }}
            </button>

          </div>
        </div>

      </div>

      <!-- Sprache -->

      <div class="col-12 mt-5" *ngIf="settings">

        <div class="card">
          <div class="card-header">
            <h5 class="card-title">{{ texts.language.title | localize }}</h5>
          </div>
          <div class="card-body">

            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">
                  <label class="form-label small">{{ texts.language.label | localize }}</label>
                  <div class="input-group input-group-merge">
                    <select [(ngModel)]="settings.Language" class="form-control">
                      <option ngValue="de">{{ texts.language.german | localize }}</option>
                      <option ngValue="en">{{ texts.language.english | localize }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row align-items-center" *ngIf="saveLanguageSuccess">
              <div class="col">
                <div class="alert alert-success mt-4" role="alert">
                  <p class="alert-heading mb-0">
                    <span class="icon me-3">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    {{ texts.language.saveSuccess | localize }}
                  </p>
                </div>
              </div>
            </div>

            <button class="btn btn-dark mt-4" *ngIf="!saveLanguageSuccess" [disabled]="isSavingLanguage" (click)="saveLanguage()">
              <span *ngIf="isSavingLanguage" class="spinner-border spinner-border-sm"></span>
              {{ texts.save | localize }}
            </button>

          </div>
        </div>

      </div>

      <!-- Passwort -->

      <div class="col-12 mt-5">

        <div class="card">

          <div class="card-header">
            <h5 class="card-title">{{ texts.password.title | localize }}</h5>
          </div>

          <div class="card-body">

            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">

                  <!-- Label -->
                  <label class="form-label small">{{ texts.password.oldPassword | localize }}</label>
                  <div class="input-group input-group-merge">
                    <input [(ngModel)]="oldPassword" type="password" class="form-control" autocomplete="current-password">
                  </div>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">

                  <!-- Label -->
                  <label class="form-label small">{{ texts.password.newPassword | localize }}</label>
                  <div class="input-group input-group-merge">
                    <input [(ngModel)]="newPassword" type="password" class="form-control" autocomplete="new-password">
                  </div>

                </div>
              </div>
            </div>

            <div class="row align-items-center" *ngIf="changePasswordError">
              <div class="col">
                <div class="alert alert-error" role="alert">
                  <p class="alert-heading mb-0">{{ changePasswordError | localize }}</p>
                </div>
              </div>
            </div>

            <div class="row align-items-center" *ngIf="changePasswordSuccess">
              <div class="col">
                <div class="alert alert-success mt-4" role="alert">
                  <p class="alert-heading mb-0">
                    <span class="icon me-3">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    {{ texts.password.saveSuccess | localize }}
                  </p>
                </div>
              </div>
            </div>

            <button class="btn btn-dark mt-4" *ngIf="!changePasswordSuccess" [disabled]="isChangingPassword" (click)="changePassword()">
              <span *ngIf="isChangingPassword" class="spinner-border spinner-border-sm"></span>
              {{ texts.save | localize }}
            </button>

          </div>
        </div>

      </div>

    </div>

  </div>

</div>